import React from 'react';
import { Alert } from 'antd';
import { useTranslation } from 'react-i18next';
import { useParcelQueryRangeDays } from './useParcelQueryRangeDays';

/** 历史包裹查询页顶部说明 */
const HistoryPageNotice: React.FC = () => {
    const { t } = useTranslation();
    const days = useParcelQueryRangeDays();
    if (days == null) {
        return null;
    }
    return <Alert type="info" showIcon className="mt-3 mb-1" message={t('parcelQueryRange.historyPageNotice', { days })} />;
};

export default HistoryPageNotice;
